module.exports = __webpack_public_path__ + "static/img/ayopppkx.2199147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ayopppkx.jpg
// module id = 0vii
// module chunks = 1